import axios from 'axios';
import targetActionTypes from './TargetFieldsConstants';
import { updateTargetFieldsID } from '../profiles/ProfilesActions';
import { HARDCODED_TARGET_IMPORT, HARDCODED_INVOICE_TARGET } from 'shared/constants/SharedConstants';

const fetchTargetMappingInformationSuccess = targetFields => ({ type: targetActionTypes.FETCH_TARGET_MAPPING_INFORMATION_SUCCESS, targetFields });
const backupTargetFieldsSuccess = () => ({ type: targetActionTypes.BACKUP_TARGET_FIELDS });
const restoreTargetFieldsSuccess = () => ({ type: targetActionTypes.RESTORE_TARGET_FIELDS });
const fetchTargetFieldsSchemasSuccess = schemas => ({ type: targetActionTypes.FETCH_TARGET_FIELDS_SCHEMAS_SUCCESS, schemas });
const fetchingTargetFields = () => ({ type: targetActionTypes.FETCHING_TARGET_FIELDS });
const disableMappedTargetFieldsSuccess = mappedFields => ({ type: targetActionTypes.DISABLE_MAPPED_TARGET_FIELDS, mappedFields });
const enableMappedTargetField = mappedFields => ({ type: targetActionTypes.ENABLE_MAPPED_TARGET_FIELDS, mappedFields });

const path = 'utm/v1/targets';

const procressTargetFieldsResponse = (targetFields, dispatch) => {
  if (targetFields.error) throw targetFields.error;
  dispatch(fetchTargetMappingInformationSuccess(targetFields.data.columns));
};

const fetchTargetByName = name => dispatch => {
  dispatch(fetchingTargetFields());
  axios.get(`${path}/columns?name=${name}`)
    .then(targetFields => procressTargetFieldsResponse(targetFields.data, dispatch))
    .catch(error => { throw error; });
};

const fetchTargetById = id => dispatch => {
  dispatch(fetchingTargetFields());
  axios.get(`${path}/${id}/columns`)
    .then(targetFields => {
      procressTargetFieldsResponse(targetFields.data, dispatch);
      dispatch(updateTargetFieldsID(targetFields.data.data.id));
    })
    .catch(error => { throw error; });
};

const fetchTargetMappingSchemas = type => dispatch => {
  axios.get(`${path}?usage=${type}`)
    .then(targetSchemas => {
      dispatch(fetchTargetFieldsSchemasSuccess(targetSchemas.data.data));
    })
    .catch(error => { throw error; });
};

const fetchInvoiceTargetMappingInformationById = () => dispatch => {
  axios.get(`${path}?usage=${HARDCODED_TARGET_IMPORT}`)
    .then(targetSchemas => {
      dispatch(fetchTargetFieldsSchemasSuccess(targetSchemas.data.data));
      dispatch(fetchTargetById(targetSchemas.data.data.find( schema => (schema.name === HARDCODED_INVOICE_TARGET)).id ));
    })
    .catch(error => { throw error; });
};

const disableMappedTargetFields = mappedFields => dispatch => dispatch(disableMappedTargetFieldsSuccess(mappedFields));

export {
  fetchTargetByName,
  fetchTargetById,
  fetchTargetMappingSchemas,
  backupTargetFieldsSuccess,
  restoreTargetFieldsSuccess,
  disableMappedTargetFields,
  enableMappedTargetField,
  fetchInvoiceTargetMappingInformationById
};



// WEBPACK FOOTER //
// ./src/redux/targetFields/TargetFieldsActions.js